import {useContext} from 'react';
import block from 'bem-cn-lite';
import {ToasterComponent} from '@gravity-ui/uikit';
import {ToastVisibilityContext} from './ToastVisibilityContext';

import './CustomToaster.scss';

const b = block('custom-toaster');

export const CustomToaster: React.FC = () => {
    const {isToasterVisible, currentToastName, toasterInstanceKey} =
        useContext(ToastVisibilityContext);

    const showOverlay =
        isToasterVisible &&
        currentToastName !== null &&
        currentToastName !== 'basket-check-success';

    return (
        <>
            {showOverlay && <div className={b()} aria-hidden="true" />}
            <ToasterComponent key={toasterInstanceKey} />
        </>
    );
};
